export enum ProjectVisibility {
  open = 'open',
  private = 'private',
  // DEPRECEATED
  public = 'public',
  publicPublic = 'public_actually_public',
}
